import { useState } from 'react';
import Avatar from 'components/base/Avatar';
import { Dropdown, Nav } from 'react-bootstrap';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import ThemeToggler from 'components/common/ThemeToggler';
import avatar1 from 'assets/img/team/72x72/avatarsysadmin.png';
import avatar2 from 'assets/img/team/72x72/avatarsysadminops.png';
import avatar3 from 'assets/img/team/72x72/avatarsysadminqa.png';
import avatar4 from 'assets/img/team/72x72/avatarmemberqa.png';
import avatar5 from 'assets/img/team/72x72/avatarmemberops.png';
import { secureStorage } from 'services/secure-storage.service';

const NavItems = () => {
  const avatar = secureStorage.getItem('avatar');

  const avatarMap: { [key: string]: string } = {
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5
  };

  const profileImage = avatarMap[avatar ?? ''] || '';

  const [show, setShow] = useState(false);

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item>
      <Nav.Item>
        <Dropdown
          autoClose={true}
          className="h-100"
          show={show}
          onToggle={setShow}
        >
          <Dropdown.Toggle
            as="div"
            onClick={() => setShow(!show)}
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center cursor-pointer"
            style={{ cursor: 'pointer' }}
          >
            <Avatar src={profileImage} size="l" />
          </Dropdown.Toggle>
          <ProfileDropdownMenu onClose={() => setShow(false)} />
        </Dropdown>
      </Nav.Item>
    </div>
  );
};
export default NavItems;
